import React, { useRef, useState } from 'react';
import { Container, Content, Version, UList, ListItem } from './styles';
import DropArrowdown from '../../../../assets/icons/DropArrowdown';
import TickCicle from '../../../../assets/icons/TickCircle';
import { useOutsideDrop } from '../../../../hooks/useOutsideDrop';
import SwitchVersion from '../../../../pages/FlowPane/Modals/SwitchVersion';
import {
  getAllFlowsTitleNames,
  getCurrent,
} from '../../../../state/flows/selectors';
import { useSelector } from 'react-redux';

const DropSelect = ({ setCritical, loadflow }) => {
  const [check, setCheck] = useState(false); // abrir/fechar drop
  const current = useSelector((state) => getCurrent(state));

  const paneFlow = useSelector((state) => state.flows.pane.flow);
  const main = paneFlow.main;

  const defaultVersion = (current) =>
    main.default ?
      (main.default !== current._id)
      : main._id !== current._id

  const List = useSelector((state) => getAllFlowsTitleNames(state));

  const wrapperRef = useRef(null);
  const clearDropdown = () => setCheck(false);

  useOutsideDrop(wrapperRef, clearDropdown);
  const [showModal, setShowModal] = useState(false);
  const [flow, setFlow] = useState(null);

  return (
    <>
      <Container ref={wrapperRef} check={check}>
        <Content onClick={() => List[0]._id && setCheck((prev) => !prev)}>
          <Version>{current.title}</Version>
          <DropArrowdown />
        </Content>

        {check && List && (
          <UList len={List.length}>
            {List.map((item, i) => (
              <ListItem
                // ==select={version === item}
                key={Math.random()}
                onClick={() => {
                  clearDropdown();

                  if (item.title !== current.title) {
                    setFlow(item);
                    setShowModal(true);
                  }
                }}
              >
                <p>
                  {item.type === 'main' ? item.title + ' (Base)' : item.title}
                  {!defaultVersion(item) ? '(P)' : null}
                </p>



                {current.title === item.title && <TickCicle />}
              </ListItem>
            ))}
          </UList>
        )}
      </Container>
      <SwitchVersion
        loadflow={loadflow}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        item={flow}
        current={current}
        setCritical={setCritical}
        selector="#root"
        className="nodrag"
      />
    </>
  );
};

export default DropSelect;
